import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=cf1d7c9c&"
import script from "./DataRow.vue?vue&type=script&lang=ts&"
export * from "./DataRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports